import { render, staticRenderFns } from "./geneVariationFx.vue?vue&type=template&id=8627690e&scoped=true"
import script from "./geneVariationFx.vue?vue&type=script&lang=js"
export * from "./geneVariationFx.vue?vue&type=script&lang=js"
import style0 from "./geneVariationFx.vue?vue&type=style&index=0&id=8627690e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8627690e",
  null
  
)

export default component.exports